// import { finished } from "stream";

export const extractValue = (objs) => {
  let new_array = []

  objs.map(obj => {
    new_array.push(obj.value)
    return obj
  })

  return new_array
}

export const getDates = (type) => {
  let initialDate = new Date()
  let finalDate = new Date()

  switch (type) {
    case 'yesterday':
      initialDate.setDate(initialDate.getDate() - 1)
      finalDate.setDate(finalDate.getDate() - 1)
      break;
    case 'thisWeek':
      initialDate.setDate(initialDate.getDate() - finalDate.getDay())
      break;
    case 'lastWeek':
      initialDate.setDate(initialDate.getDate() - (initialDate.getDay() + 7))
      finalDate.setDate(finalDate.getDate() - (finalDate.getDay() + 1))
      break;
    case 'thisMonth':
      initialDate.setDate(1)
      break;
    case 'lastMonth':
      initialDate = new Date(initialDate.getFullYear(), initialDate.getMonth() - 1, 1)
      finalDate = new Date(finalDate.getFullYear(), finalDate.getMonth(), 0)
      break;
    case 'thisYear':
      initialDate = new Date(initialDate.getFullYear(), 0, 1)
      finalDate = new Date()
      break;
    case 'lastYear':
      initialDate = new Date(initialDate.getFullYear() - 1, 0, 1)
      finalDate = new Date(finalDate.getFullYear() - 1, 11, 31)
      finalDate.setHours(23)
      finalDate.setMinutes(59)
      finalDate.setSeconds(59)
      break;
    case 'last15days':
      initialDate.setDate(initialDate.getDate() - 14)
      break;
    case 'last30days':
      initialDate.setDate(initialDate.getDate() - 29)
      break;
    case 'last45days':
      initialDate.setDate(initialDate.getDate() - 44)
      break;
    case 'last60days':
      initialDate.setDate(initialDate.getDate() - 59)
      break;
    case 'last90days':
      initialDate.setDate(initialDate.getDate() - 89)
      break;
    case 'thisSemester':
      if (initialDate.getMonth() <= 5) {
        initialDate = new Date(initialDate.getFullYear(), 0, 1)
        finalDate = new Date(finalDate.getFullYear(), 6, 0)
        finalDate.setHours(23)
        finalDate.setMinutes(59)
        finalDate.setSeconds(59)
      }
      else {
        initialDate = new Date(initialDate.getFullYear(), 6, 1)
        finalDate = new Date(finalDate.getFullYear(), 11, 31)
        finalDate.setHours(23)
        finalDate.setMinutes(59)
        finalDate.setSeconds(59)
      }
      break;
    case 'lastSemester':
      if (initialDate.getMonth() > 5) {
        initialDate = new Date(initialDate.getFullYear(), 0, 1)
        finalDate = new Date(finalDate.getFullYear(), 5, 30)
        finalDate.setHours(23)
        finalDate.setMinutes(59)
        finalDate.setSeconds(59)
      }
      else {
        initialDate = new Date(initialDate.getFullYear() - 1, 6, 1)
        finalDate = new Date(finalDate.getFullYear() - 1, 11, 31)
        finalDate.setHours(23)
        finalDate.setMinutes(59)
        finalDate.setSeconds(59)
      }
      break;
    case 'thisTrimester':
      initialDate.setDate(initialDate.getDate() - 59)
      break;
    case 'lastTrimester':
      initialDate.setDate(initialDate.getDate() - 59)
      break;
    case 'thisBimester':
      if (initialDate.getMonth() % 2 == 0) {
        initialDate = new Date(initialDate.getFullYear(), initialDate.getMonth(), 1)
        finalDate = new Date(finalDate.getFullYear(), finalDate.getMonth() + 2, 0)
        finalDate.setHours(23)
        finalDate.setMinutes(59)
        finalDate.setSeconds(59)
      }
      else {
        initialDate = new Date(initialDate.getFullYear(), initialDate.getMonth() - 1, 1)
        finalDate = new Date(finalDate.getFullYear(), finalDate.getMonth() + 1, 0)
        finalDate.setHours(23)
        finalDate.setMinutes(59)
        finalDate.setSeconds(59)
      }
      break;
    case 'lastBimester':
      if (initialDate.getMonth() % 2 == 0) {
        initialDate = new Date(initialDate.getFullYear(), initialDate.getMonth() - 2, 1)
        finalDate = new Date(finalDate.getFullYear(), finalDate.getMonth(), 0)
        finalDate.setHours(23)
        finalDate.setMinutes(59)
        finalDate.setSeconds(59)
      }
      else {
        initialDate = new Date(initialDate.getFullYear(), initialDate.getMonth() - 3, 1)
        finalDate = new Date(finalDate.getFullYear(), finalDate.getMonth() - 1, 0)
        finalDate.setHours(23)
        finalDate.setMinutes(59)
        finalDate.setSeconds(59)
      }
      break;
    default:
  }

  let initialDay = initialDate.getDate()
  let initialMonth = initialDate.getMonth() + 1
  let initialYear = initialDate.getFullYear()
  let finalDay = finalDate.getDate()
  let finalMonth = finalDate.getMonth() + 1
  let finalYear = finalDate.getFullYear()

  initialDay = initialDay < 10 ? '0' + initialDay : initialDay
  initialMonth = initialMonth < 10 ? '0' + initialMonth : initialMonth
  initialYear = initialYear < 10 ? '0' + initialYear : initialYear
  finalDay = finalDay < 10 ? '0' + finalDay : finalDay
  finalMonth = finalMonth < 10 ? '0' + finalMonth : finalMonth
  finalYear = finalYear < 10 ? '0' + finalYear : finalYear

  const initialDatetime = `${initialYear}-${initialMonth}-${initialDay}T00:00:00`
  const finalDatetime = `${finalYear}-${finalMonth}-${finalDay}T23:59:59`

  const Datetime = initialDatetime + '/' + finalDatetime

  return Datetime
}

export const getPrecision = (type) => {
  if (['thisYear', 'lastYear'].indexOf(type) !== -1) {
    return 'month'
  }

  return 'day'
}
